import { Middleware, RequestContext } from '../../../generated/api';
import { retry } from '../../../utils/utils';
import { auth } from '../../firebase/firebaseAccess';

export default class BearerAuthMiddleware implements Middleware {
  constructor(private readonly token?: string | (() => Promise<string>)) {
    this.token = token;
  }

  async pre(request: RequestContext) {
    const user = auth.currentUser;

    let token =
      typeof this.token === 'function' ? await this.token() : this.token;

    if (!token && user != null) {
      token = await retry(attempt => user.getIdToken(attempt > 2), 5);
    }

    return {
      ...request,
      init: {
        ...request.init,
        headers: {
          ...request.init.headers,
          ...(token ? { Authorization: `Bearer ${token}` } : undefined),
          ['x-pop-platform']: 'psl',
        },
      },
    };
  }
}
